import React, { useState, useEffect } from "react";
import ThunderIcon from "./ThunderIcon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "./InfoIcon";
import ChecktickIcon from "./ChecktickIcon";
import data from "../../data/bulletPoints.json";

const ScontrinoFooter = ({ gestionePrevidenziale, ibridoCase, parameters }) => {
  const [isPrezzoAggiuntivo, setIsPrezzoAggiuntivo] = useState(false);

  useEffect(() => {
    if (
      gestionePrevidenziale === "0" ||
      gestionePrevidenziale === "1" ||
      gestionePrevidenziale === "5"
    ) {
      if (ibridoCase !== 0) {
        setIsPrezzoAggiuntivo(true);
      } else {
        setIsPrezzoAggiuntivo(false);
      }
    } else {
      setIsPrezzoAggiuntivo(false);
    }

    if (parameters.ibridoCase !== undefined) {
      setIsPrezzoAggiuntivo(parseInt(parameters.ibridoCase));
    }
  }, [gestionePrevidenziale, ibridoCase, parameters.ibridoCase]);

  return (
    <div className="pb-40 pt-20 flex flex-col items-center justify-center">
      <span className="text-gray-400 text-center">
        Costo FidoCommercialista: 264,00 €/anno
      </span>
      {isPrezzoAggiuntivo !== 0 && (
        <span className="text-gray-400 text-center">
          150,00 €/una tantum in caso di apertura nuova attività
          <Tooltip
            title={
              "Costo aggiuntivo per registrazione camera di commercio e pratiche agli enti (apertura partita iva  gratuita)"
            }
            arrow
            style={{ position: "relative", zIndex: "0" }}
          >
            <IconButton>
              <InfoIcon className="dark:fill-[white]" />
            </IconButton>
          </Tooltip>
        </span>
      )}
      <div className="py-4">
        <ul>
          {data?.points.map((point, index) => {
            return (
              <li key={`point-${index}`} className="flex flex-row gap-x-2">
                <ChecktickIcon />
                {point}
              </li>
            );
          })}
        </ul>
      </div>
      <span className="flex flex-col text-center md:mt-0 mt-2 md:text-left md:flex-row items-center gap-x-2">
        <ThunderIcon className="dark:fill-white" /> Un nostro commercialista ti
        contatterà entro 24 ore
      </span>
      <button className="p-8 bg-orange-400 text-white rounded-md pt-2 pb-2 mt-3 duration-300">
        <a
          href="https://fidocommercialista.it/registrati/"
          target="_blank"
          rel="noreferrer"
          className="text-white"
        >
          Prenota una consulenza gratuita
        </a>
      </button>
    </div>
  );
};

export default ScontrinoFooter;
